import {
  Typography, TypographyProps, Box, BoxProps, styled,
} from '@mui/material';

export const BodyTypography = styled(Typography)<TypographyProps>((props) => ({
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
}));

export const Bold = styled(Box)<BoxProps>(({ theme }) => ({
  fontWeight: '800',
  display: 'inline',
}));
